import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, of } from 'rxjs';

import { BaseMiscApiService } from '@common/api/base-misc-api.service';
import { AppConstants } from '@apps/app.constants';
import { Its2Constants } from '../its2.constants';
import { SimpleEntityApi } from './models/back/simple-entity-api';

@Injectable({
    providedIn: 'root'
})
export class ItsmEntitiesMiscApiService extends BaseMiscApiService
{
    constructor (http: HttpClient)
    {
        super(http);

        this.segmentRoot = AppConstants.Configuration.apiUrlIts2;
        this.segmentApi = `/${Its2Constants.BaseApi}/entities`;
    }

    getEntities (): Observable<SimpleEntityApi[]>
    {
        return this.get('');
    }

    getSubEntities (entityId: string): Observable<string[]>
    {
        return this.get(`/${entityId}/subentities`);
    }

    saveSubEntities (entityId: string, subEntities: string[]): Observable<boolean>
    {
        return this.put('/subentities', { entityId, subEntities });
    }
}
